export default __webpack_public_path__ + "static/media/nerede_3.45b44528.JPG";